import React from 'react'
import styles from './styles' // Importing styles

// material
import { styled } from '@material-ui/core/styles'
import { Box, Typography, Grid, withStyles } from '@material-ui/core'
import { CoreButton } from 'src/components/core'

// ----------------------------------------------------------------------
// TODO INLINE STYLES KALDRILACAK @SULEYMAN
const RootStyle = styled(Grid)(() => ({
  width: '100%', // Full width on mobile
  maxWidth: 1200,
  backgroundColor: '#F4F6F8',
  height: 144,
  padding: '40px 30px', // Combined padding
  borderRadius: 16,
  marginTop: 20,
  '@media (max-width: 600px)': {
    padding: '40px 12px', // Adjust padding for mobile
    gap: '16px', 
    width: '380px !important',
  },
}))

const Enterprise = props => {
  const { classes } = props

  const onClick = () => {
    if (window.Intercom) {
      window.Intercom('showMessages')
    }
  }
  return (
    <RootStyle>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box display="flex" flexDirection="column" marginRight={2}>
          <Typography className={classes.typographyContact} paragraph>
            Business Plan
          </Typography>
          <Box display="flex">
            <Typography className={classes.typographyContact2} paragraph>
            Want to provide in-app authentication for more users?
            </Typography>
          </Box>
        </Box>
        <CoreButton
          variant="outlined"
          color="secondary"
          size="medium"
          className={classes.buttonContact}
          onClick={onClick}
        >
          Contact us
        </CoreButton>
      </Box>
    </RootStyle>
  )
}

export default withStyles(styles)(Enterprise)